import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import logoFooter from "../../assets/images/svg/logoFooter.svg";
import iconeInstagram from "../../assets/images/svg/iconeInstagram.svg";
import iconeTikTok from "../../assets/images/svg/iconeTikTok.svg";
import iconeYoutube from "../../assets/images/svg/iconeYouTube.svg";
import botaoSubscribe from "../../assets/images/svg/botaoSubscribe.svg";

export default function Footer() {
  const navigate = useNavigate();

  const handleScroll = (selector) => {
    const element = document.querySelector(selector);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleKeyPress = (event, action) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      action();
    }
  };

  return (
    <footer className="footer-container" role="contentinfo">
      <div className="container pt-5">
        <div className="row">
          <nav
            className="col-md-3 d-flex d-md-block flex-column flex-md-row align-items-center footer-menu text-center text-md-start"
            role="navigation"
            aria-label="Footer navigation"
          >
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() =>
                window.open(
                  "https://forms.office.com/pages/responsepage.aspx?id=V_GNLE1xrkacvoyZrxNXvUYowLV_R6JNjytDt9UarBNURUdJNlA4MEdLRTRZWUc1UlVBUkdHMlZENS4u&route=shorturl",
                  "_blank"
                )
              }
              onKeyPress={(e) =>
                handleKeyPress(e, () =>
                  window.open(
                    "https://forms.office.com/pages/responsepage.aspx?id=V_GNLE1xrkacvoyZrxNXvUYowLV_R6JNjytDt9UarBNURUdJNlA4MEdLRTRZWUc1UlVBUkdHMlZENS4u&route=shorturl",
                    "_blank"
                  )
                )
              }
              aria-label="Open Work With Us form in new tab"
            >
              WORK WITH US
            </div>
            {/* STEP INTO CLAWZ */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() => handleScroll(".video-container")}
              onKeyPress={(e) =>
                handleKeyPress(e, () => handleScroll(".video-container"))
              }
              aria-label="Scroll to Step into Clawz section"
            >
              STEP INTO CLAWZ
            </div>
            {/* LICENSED PLUSHIES */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() => handleScroll(".container-kawaii")}
              onKeyPress={(e) =>
                handleKeyPress(e, () => handleScroll(".container-kawaii"))
              }
              aria-label="Scroll to Licensed Plushies section"
            >
              LICENSED PLUSHIES
            </div>
            {/* MEET THE Z GANG */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() => handleScroll(".cartas-container")}
              onKeyPress={(e) =>
                handleKeyPress(e, () => handleScroll(".cartas-container"))
              }
              aria-label="Scroll to Meet the Z Gang section"
            >
              MEET THE Z GANG
            </div>
            {/* LOCATIONS */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() => handleScroll(".card-gps-container")}
              onKeyPress={(e) =>
                handleKeyPress(e, () => handleScroll(".card-gps-container"))
              }
              aria-label="Scroll to Locations section"
            >
              LOCATIONS
            </div>
            {/* SOCIAL */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() =>
                window.open(
                  "https://linktr.ee/clawz.us?fbclid=PAZXh0bgNhZW0CMTEAAafWRBeph1SP-W-f8HlcPs1CbIgsk89c4cxvPKwDf6UliR89dhiXrDjO0x7Wrg_aem_vanZHtXunJtxahHAHSiagQ",
                  "_blank"
                )
              }
              onKeyPress={(e) =>
                handleKeyPress(e, () =>
                  window.open(
                    "https://linktr.ee/clawz.us?fbclid=PAZXh0bgNhZW0CMTEAAafWRBeph1SP-W-f8HlcPs1CbIgsk89c4cxvPKwDf6UliR89dhiXrDjO0x7Wrg_aem_vanZHtXunJtxahHAHSiagQ",
                    "_blank"
                  )
                )
              }
              aria-label="Open Social media links in new tab"
            >
              SOCIAL
            </div>
            {/* GALLERY */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() => handleScroll(".galeria-container")}
              onKeyPress={(e) =>
                handleKeyPress(e, () => handleScroll(".galeria-container"))
              }
              aria-label="Scroll to Gallery section"
            >
              GALLERY
            </div>
            {/* EVERYBODY WINS */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() => {
                const element1 = document.querySelector(".scrollClawrranty1");
                if (element1) {
                  element1.scrollIntoView({ behavior: "smooth" });
                }
                const element2 = document.querySelector(".scrollClawrranty2");
                if (element2) {
                  element2.scrollIntoView({ behavior: "smooth" });
                }
              }}
              onKeyPress={(e) =>
                handleKeyPress(e, () => {
                  const element1 = document.querySelector(".scrollClawrranty1");
                  if (element1) {
                    element1.scrollIntoView({ behavior: "smooth" });
                  }
                  const element2 = document.querySelector(".scrollClawrranty2");
                  if (element2) {
                    element2.scrollIntoView({ behavior: "smooth" });
                  }
                })
              }
              aria-label="Scroll to Everybody Wins section"
            >
              EVERYBODY WINS
            </div>
            {/* NEWS */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() => handleScroll(".titulo-galeria-news")}
              onKeyPress={(e) =>
                handleKeyPress(e, () => handleScroll(".titulo-galeria-news"))
              }
              aria-label="Scroll to News section"
            >
              NEWS
            </div>
            {/* JOIN THE REBELLION */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() =>
                window.open(
                  "https://forms.office.com/pages/responsepage.aspx?id=V_GNLE1xrkacvoyZrxNXvUYowLV_R6JNjytDt9UarBNUQTVRV1BKNjJQREhWTDQ5MkRCUTFWSFVPTy4u&route=shorturl",
                  "_blank"
                )
              }
              onKeyPress={(e) =>
                handleKeyPress(e, () =>
                  window.open(
                    "https://forms.office.com/pages/responsepage.aspx?id=V_GNLE1xrkacvoyZrxNXvUYowLV_R6JNjytDt9UarBNUQTVRV1BKNjJQREhWTDQ5MkRCUTFWSFVPTy4u&route=shorturl",
                    "_blank"
                  )
                )
              }
              aria-label="Open Join the Rebellion form in new tab"
            >
              JOIN THE REBELLION
            </div>
            {/* CONTACT US */}
            <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() => window.open("mailto:clawz@clawz.us")}
              onKeyPress={(e) =>
                handleKeyPress(e, () => window.open("mailto:clawz@clawz.us"))
              }
              aria-label="Open email client to contact Clawz"
            >
              CONTACT US
            </div>
            {/* <div
              className="footer-item"
              role="button"
              tabIndex="0"
              onClick={() => handleScroll(".footer-container")}
              onKeyPress={(e) =>
                handleKeyPress(e, () => handleScroll(".footer-container"))
              }
              aria-label="Scroll to Contact Us section"
            >
              CONTACT US
            </div> */}
          </nav>
          <div
            className="col-md-6 d-flex flex-column align-items-center"
            role="complementary"
            aria-label="Company information"
          >
            <img
              className="footer-logo"
              src={logoFooter}
              alt="Clawz Entertainment Logo - Premium Plush Machine Experience"
            />
            <div
              className="d-flex justify-content-center"
              role="navigation"
              aria-label="Social media links"
            >
              <a
                href="https://www.instagram.com/clawz.us"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Clawz Entertainment on Instagram"
              >
                <img
                  title="Instagram"
                  className="footer-social-icon"
                  src={iconeInstagram}
                  alt=""
                />
              </a>
              <a
                href="https://www.tiktok.com/@clawz.us"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Clawz Entertainment on TikTok"
              >
                <img
                  title="TikTok"
                  className="footer-social-icon"
                  src={iconeTikTok}
                  alt=""
                />
              </a>
              <a
                href="https://www.youtube.com/@clawzplushiesplayground"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Subscribe to Clawz Entertainment on YouTube"
              >
                <img
                  title="YouTube"
                  className="footer-social-icon"
                  src={iconeYoutube}
                  alt=""
                />
              </a>
            </div>

            <div className="footer-subscribe" role="heading" aria-level="2">
              Subscribe and be the first to know!
            </div>
            <a
              href="https://forms.office.com/pages/responsepage.aspx?id=V_GNLE1xrkacvoyZrxNXvUYowLV_R6JNjytDt9UarBNUQTVRV1BKNjJQREhWTDQ5MkRCUTFWSFVPTy4u&route=shorturl"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Subscribe to Clawz Entertainment Newsletter"
            >
              <img
                className="footer-subscribe-button pointer"
                src={botaoSubscribe}
                alt=""
              />
            </a>
            {/* <div
              className="footer-subscribe-text text-center text-md-start"
              role="contentinfo"
            >
              By signing up to receive emails from Clawz, you agree to our
              Privacy Policy.
              <br />
              We treat your info responsibly. Unsubscribe anytime.
            </div> */}
          </div>
          <div className="col-md-3 d-flex d-md-block flex-column flex-md-row align-items-center footer-address text-center text-md-start">
            <div
              onClick={() =>
                window.open(
                  "https://maps.app.goo.gl/64fCX6LFKdzHrra4A",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  window.open(
                    "https://maps.app.goo.gl/64fCX6LFKdzHrra4A",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }
              }}
              className="ticker-item"
              role="button"
              tabIndex="0"
              aria-label="Open Clawz Plushies Playground location in Google Maps"
            >
              CLAWZ PLUSHIES PLAYGROUND
              <br />
              MIAMI INTERNATIONAL MALL
              <br />
              <br />
              1455 NW 107TH AVE, DORAL, FL
              <br />
              33172, USA
              <br />
              <br />
            </div>
            <div className="d-flex flex-column">
              <div
                className="ticker-item my-0"
                onClick={() => {
                  if (
                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                      navigator.userAgent
                    )
                  ) {
                    window.location.href = "tel:+17867750924";
                  }
                }}
                role="button"
                tabIndex="0"
                aria-label="Call Clawz Entertainment"
              >
                +1 786 775 0924
              </div>

              <div
                className="ticker-item my-0"
                onClick={() => window.open("mailto:clawz@clawz.us")}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    window.open("mailto:clawz@clawz.us");
                  }
                }}
                role="button"
                tabIndex="0"
                aria-label="Send email to Clawz Entertainment"
              >
                CLAWZ@CLAWZ.US
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ padding: "70px 0 30px 0" }}>
          <div className="col-md-12">
            <div className="footer-copyright" role="contentinfo">
              © CLAWZ PLUSHIES PLAYGROUND 2025, ALL RIGHTS RESERVED. MIAMI
              INTERNATIONAL MALL 1455 NW 107th Ave, Doral, FL 33172, USA
            </div>
            <div className="footer-copyright-text" role="contentinfo">
              The copyrights of the documents, photographs, character images,
              etc. on this website belong to CLAWZ PLUSHIE PLAYGROUND, Ltd. or
              their respective copyright holders. Copying or modifying any
              <br />
              of these works, in whole or in part, without the permission of the
              copyright holder is prohibited by copyright law.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
